<template>
  <div class="cp-order-history main">
    <div class="divider" />
    <div class="row">
      <p>
        <i class="fa fa-list icon" />Order History for <b>{{ b.name }}</b>
      </p>
      <div v-if="selected" class="time-periods">
        <p class="is-flex" style="background-color: white; color: grey">
          <span style="flex: 1" @click="selected = null">
            <i class="fa fa-chevron-left" style="margin-right: 6px" />
            <span v-if="showAllTimePeriods">{{ selected }}</span>
            <span v-else>{{ $t(`order-history.${selected}`) }}</span>
          </span>
          <!-- <span @click="download">
            Download&nbsp;<i class="fa fa-download" />
          </span> -->
        </p>
        <p v-if="!orders"><i class="fa fa-cog fa-spin" />&nbsp;Loading</p>
        <p
          v-if="orders && !orders.length"
          class="has-text-primary"
          style="background-color: white"
          @click="selected = null"
        >
          No orders during this time period
        </p>
        <p v-for="o in orders" :key="o.id" @click="openOrder(o.id)">
          <span class="date-ref">
            <span class="date">{{ prettyDate(o) }}</span>
            #{{ o.ref }}
          </span>
          <span class="fulfilment-icon" @click.stop="gotoOrder(o.id)">
            <i class="fa" :class="fulfilmentIcon(o.order_type)" />
          </span>

          <span class="order-value">
            <span style="font-weight: 400">{{
              currencySymbol(b.country)
            }}</span>
            {{ o.order_value }}
          </span>
          <!-- <span class="is-pulled-right">
            <i class="fa fa-external-link-alt" />
          </span> -->
        </p>
      </div>
      <div v-else class="time-periods">
        <div v-if="showAllTimePeriods">
          <p
            @click="showAllTimePeriods = false"
            style="background-color: white; color: grey"
          >
            <i class="fa fa-chevron-left" style="padding: 3px" />
            Recent Time Periods
          </p>
          <p
            v-for="p in timePeriods"
            :key="p.year_month"
            @click="getOrderHistory(p.year_month)"
          >
            {{ p.year_month }}
            <span class="is-pulled-right">
              <span v-if="isSuperUser()" class="count">{{ p.count }}</span>
              <i class="fa fa-chevron-right" />
            </span>
          </p>
        </div>
        <div v-else>
          <p v-for="s in recentPeriods" :key="s" @click="getOrderHistory(s)">
            {{ $t(`order-history.${s}`) }} <i class="fa fa-chevron-right" />
          </p>
          <!-- <p @click="getOrderHistory('today')">
            Today <i class="fa fa-chevron-right" />
          </p>
          <p @click="getOrderHistory('past-3-days')">
            Past 3 Days <i class="fa fa-chevron-right" />
          </p> -->
          <p
            @click="showAllTimePeriods = true"
            style="color: grey; background-color: white"
          >
            <i v-if="timePeriods" class="fa fa-ellipsis-h" />
            <i v-else class="fa fa-spinner fa-spin" />
            &nbsp;{{ $t("order-history.more-time-periods") }}
            <i class="fa fa-chevron-right" />
          </p>
        </div>
      </div>
    </div>
    <div style="height: 100px" />
  </div>
</template>


<script>
export default {
  name: "CPOrderHistory",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      showAllTimePeriods: false,
      timePeriods: null,
      selected: null, // selected time period
      orders: null,
      recentPeriods: [
        "today",
        "past-3-days",
        "past-7-days",
        "this-month",
        "last-month",
      ],
      //   timePeriods: [
      //     { year_month: "2022-03", count: 32 },
      //     { year_month: "2022-02", count: 99 },
      //     { year_month: "2022-01", count: 2 },
      //   ],
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
  },
  mounted() {
    console.log("mounted CPOrderHistory"); // this constantly re-mounts...!!!
    if (!this.timePeriods) this.getOrderHistoryCounts();
  },
  methods: {
    download() {
      // convert orders json array to csv
      this.infoToast("Download CSV coming soon!", "top");
    },
    fulfilmentIcon(type) {
      if (type === "take-away") return "fa-walking  has-text-link";
      if (type === "delivery") return "fa-shipping-fast has-text-grey";
      if (type === "dine-in") return "fa-users has-text-orange";
      return "fa-question has-text-danger";
    },
    prettyDate(o) {
      //   return new Date(o.created_at).toISOString().split("T")[0]; // returns date like YYYY-MM-DD
      return new Date(o.created_at).toISOString().split("T")[0].slice(5); // returns date like MM-DD
    },
    openOrder(id) {
      // this.goto(`/cao/${o.id}`)
      var url = process.env.VUE_APP_HOST + `/cao/${id}`;
      window.open(url, "_blank");
    },
    gotoOrder(id) {
      this.goto(`/cao/${id}`);
    },
    getOrderHistoryCounts() {
      this.$store
        .dispatch("getCommerceOrderHistoryCountsForBusiness", this.b.id)
        .then((res) => {
          this.timePeriods = res.data;
        })
        .catch((err) => this.apiError(err));
    },
    getOrderHistory(period) {
      this.selected = period;
      this.orders = null;
      var payload = {
        business_id: this.b.id,
        period: period,
      };
      this.$store
        .dispatch("getCommerceOrderHistoryForPeriod", payload)
        .then((res) => {
          this.orders = res.data;
          if (!this.orders) this.orders = [];
        })
        .catch((err) => this.apiError(err));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.time-periods {
  margin: 10px 0;
}
.time-periods p {
  padding: 8px;
  border: 1px solid #ccc;
  margin: 8px 0;
  border-radius: 4px;
  background-color: whitesmoke;
  font-weight: 450;
  /* color: grey; */
}
.time-periods p:hover {
  border: 1px solid var(--info);
  box-shadow: 0 0 2px grey;
}
.fa-chevron-right {
  float: right;
  padding: 3px;
}
.date {
  font-weight: 400;
  color: grey;
}
.date-ref {
  width: 110px;
  display: inline-block;
}
.fulfilment-icon {
  width: 30px;
  display: inline-block;
  text-align: center;
}
.order-value {
  width: 60px;
  display: inline-block;
  text-align: right;
}
.count {
  background-color: white;
  opacity: 0.6;
  width: 30px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
  border-radius: 6px;
}
</style>
